export const navigation = [
  {
    pageName: 'Home',
    link: '/home'
  },
  {
    pageName: 'Todo',
    link: '/todo'
  },
  {
    pageName: 'Note',
    link: '/note'
  },
  {
    pageName: 'Contact',
    link: '/contact'
  },
  {
    pageName: 'Profile',
    link: '/profile'
  }
]
